// Auto generated file, do not manually modify!
// com.hotpads.satellite.client.renterprofile.dto.SatelliteRenterProfileLeadIntentValue

export enum SatelliteRenterProfileLeadIntentValue {
  HIGH_INTENT = 'HIGH_INTENT',
}

export const SatelliteRenterProfileLeadIntentValue_values = [
  SatelliteRenterProfileLeadIntentValue.HIGH_INTENT,
] as const;
